import { type FC } from 'react';
import cx from 'classnames';

import { type VoidFunction } from 'src/lib/types';

import { Actions } from './views/Actions';
import { RecentlyUsedTemplates } from './views/RecentlyUsedTemplates';
import styles from './NewProjectWidget.module.scss';
import { useHandlers } from './useHandlers';

export interface NewProjectWidgetProps {
  className?: string;
  onFlowFinished?: VoidFunction;
  inPopupMode?: boolean;
}

export const NewProjectWidget: FC<NewProjectWidgetProps> = ({
  className,
  onFlowFinished,
  inPopupMode,
}) => {
  const { handleWidgetAction } = useHandlers({
    onFlowFinished,
    inPopupMode,
  });

  return (
    <div
      className={cx(styles.root, className)}
      data-testid="newProjectWidget"
    >
      <Actions
        className={styles.actions}
        onAction={handleWidgetAction}
      />

      <RecentlyUsedTemplates
        className={styles.recentlyUsedTemplates}
        onWidgetAction={handleWidgetAction}
      />
    </div>
  );
};
